import Name from './Name';

export default Name;
